import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import AutoBindComponent from "../../common/AutoBindComponent";
import unsavedDataDialogHandler from "../../common/UnsavedDataDialogHandler";
import * as types from "../../../constants/ComponentConstants";
import * as layoutActions from "../../../actions/layoutActions";
import * as beads from "../../../actions/beadActions";

import InvesteringenForm from "./InvesteringenForm";
import InvesteringenPageHelper from "./InvesteringenPageHelper";
import convertToLabelValuePair from "../../../util/convertToLabelValuePair.js";
import redirector from '../../../util/redirector';
import ConfirmModal from "../../common/ConfirmModal";

class InvesteringenPage extends AutoBindComponent {
    constructor(props, context) {
        super(props, context);

        this.pageHelper = new InvesteringenPageHelper(this, redirector);
    }

    componentWillMount() {
        this.pageHelper.init();
    }

    handleOnDeleteOpbrengstKostInvestering(event, id) {
        this.pageHelper.deleteOpbrengstKostInvestering(id);
    }

    handleOnShowDeleteModal(event, id) {
        window.parent.scrollTo(0, 450);
        this.pageHelper.openModal(id);
    }

    handleOnEditInvestering(event, id) {
        this.pageHelper.goToInvesteringEditWijzig(id);
    }

    render() {
        if (!this.pageHelper.isReadyToRender())
            return null;

        return (<div>
            <ConfirmModal
                hookToTop
                isOpen={this.state.modalIsOpen}
                mainText="Ben je zeker dat je deze investering wil verwijderen?"
                confirmAction={() => this.pageHelper.deleteOpbrengstKostInvestering()}
                cancelAction={() => this.pageHelper.closeModal()}
                confirmText="Verwijder"
                cancelText="Annuleer" />
            <InvesteringenForm
                color={types.COLOR_PINK_LIGHT}
                model={this.state.investeringen}
                hoofdCategorien={this.props.hoofdCategorien}
                typesInvestering={this.props.typesInvestering}
                showDeleteModal={this.handleOnShowDeleteModal}
                goToInvesteringEdit={() => this.pageHelper.goToInvesteringEdit()}
                goToInvesteringEditWijzig={this.handleOnEditInvestering}
            />
        </div>);
    }
}

InvesteringenPage.propTypes = {
};

function mapStateToProps(state, ownProps) {
    const dossierId = ownProps.params.dossierId;

    return {
        dossierId: dossierId,
        hoofdCategorien: convertToLabelValuePair(state.referentie.hoofdCategorienInvestering),
        typesInvestering: convertToLabelValuePair(state.referentie.typesInvestering)
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        loadLayout: bindActionCreators(layoutActions.loadFinancieelPageLayout, dispatch),
        beadsLoaded: bindActionCreators(beads.beadsLoaded, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(unsavedDataDialogHandler(InvesteringenPage));